import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  NavLink, Route, Switch, useRouteMatch,
} from 'react-router-dom';
import Organization from './Tabs/Organization';
import Language from './Tabs/Language';

const Settings = () => {
  const translate = useIntl();
  const { path, url } = useRouteMatch();
  const TabsData = {
    0: {
      label: translate.formatMessage({ id: 'settings.tab1' }),
      content: <Organization />,
      link: '',
      path: `${path}`,
      tabId: 0,
    },
    1: {
      label: translate.formatMessage({ id: 'settings.tab2' }),
      content: <Language />,
      link: '/language',
      path: `${path}/language`,
      tabId: 1,
    },
    // 2: {
    //   label: translate.formatMessage({ id: 'settings.tab3' }),
    //   content: <></>,
    //   link: '/notifications',
    //   path: `${path}/notifications`,
    //   tabId: 2,
    // },
  };
  useEffect(() => {
  }, []);
  return (
    <div className="settings__monitoring">
      <div className="settings__title">{ translate.formatMessage({ id: 'settings.title' })}</div>
      <div className="settings-monitoring">
        {Object.values(TabsData).map((tab) => (
          <NavLink
            key={tab.tabId}
            to={`${url}${tab.link}`}
            className="settings-link"
            activeClassName="settings-link_active"
            exact
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <Switch>
        {Object.values(TabsData).map((tab, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Route key={index} path={tab.path} exact>
            {tab.content}
          </Route>
        ))}
      </Switch>
    </div>
  );
};

export default Settings;
